<template>
  <div class="legal-page">
    <div class="container">
      <h1>Contact Us</h1>
      
      <section>
        <h2>Get in Touch</h2>
        <p>We value your feedback and are here to help. If you have any questions, suggestions, or issues regarding our games or website, please don't hesitate to reach out to us.</p>
      </section>

      <section>
        <h2>Support</h2>
        <p>For technical support, bug reports, or general inquiries, please email us at:</p>
        <div class="contact-card">
          <span class="email-icon">✉️</span>
          <a href="mailto:xendor@xendor.pub" class="email-link">xendor@xendor.pub</a>
        </div>
      </section>

      <section>
        <h2>Response Time</h2>
        <p>We try our best to respond to all inquiries within 24-48 hours. Please note that response times may vary during weekends and holidays.</p>
      </section>
      
      <div class="back-link">
        <router-link to="/">← Back to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>

<style scoped>
/* Reusing styles from PrivacyPolicy for consistency */
.legal-page {
  padding: 40px 20px;
  color: #fff;
  min-height: 80vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 30px;
  color: #fff;
}

section {
  margin-bottom: 30px;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #e0eaff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}

p {
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 10px;
}

.contact-card {
  background: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
}

.email-icon {
  font-size: 24px;
}

.email-link {
  color: #667eea;
  font-size: 1.2rem;
  text-decoration: none;
  font-weight: bold;
}

.email-link:hover {
  text-decoration: underline;
}

.back-link {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.back-link a {
  display: inline-block;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: white;
  text-decoration: none;
  transition: background 0.3s;
}

.back-link a:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>
